export default __webpack_public_path__ + "static/media/lottery-banner.76b535fc.webp";